<template>
  <div>
    <app-header></app-header>
    <router-view></router-view>
    <app-footer></app-footer>
  </div>
</template>

<script>
import AppHeader from "../../components/common/AppHeader";
import AppFooter from "../../components/common/AppFooter";
export default {
  components: {
    AppHeader,
    AppFooter
  }
};
</script>